import { IAppState } from '../../redux';

export function selectPromotionCost(state: IAppState): number {
  return state.checkoutInfo.promotionCost;
}
